import { NoteType } from "../../slices/notes/Types";

export const notesSagaActionTypes = {
  callGetFormFieldsSalesNoteSaga: "callGetFormFieldsSalesNoteSaga",
  callAddFormSalesNoteSaga: "callAddFormSalesNoteSaga",
  callGetSalesNoteFormDetailSaga: "callGetSalesNoteFormDetailSaga",
  callUpdateFormSalesNoteSaga: "callUpdateFormSalesNoteSaga",
  callGetNotesListSaga: "callGetNotesListSaga",
  callAddNoteSaga: "callAddNoteSaga",
  callUpdateNoteSaga: "callUpdateNoteSaga",
  callDeleteNoteSaga: "callDeleteNoteSaga",
};

export const getFormFieldsSalesNoteSagaAction: () => {
  type: string;
} = () => {
  return {
    type: notesSagaActionTypes.callGetFormFieldsSalesNoteSaga,
  };
};

export type addFormSalesNoteSagaActionPayloadType = {
  source: "UserPartnerNote";
  partner_id: number;
  submitted_by: number;
  data: { label: string; value: boolean }[];
};
export const addFormSalesNoteSagaAction: (
  payload: addFormSalesNoteSagaActionPayloadType
) => {
  type: string;
  payload: addFormSalesNoteSagaActionPayloadType;
} = (payload) => {
  return {
    type: notesSagaActionTypes.callAddFormSalesNoteSaga,
    payload: payload,
  };
};

export const getSalesNoteFormDetailSagaAction: (partnerID: number) => {
  type: string;
  partnerID: number;
} = (partnerID) => {
  return {
    type: notesSagaActionTypes.callGetSalesNoteFormDetailSaga,
    partnerID: partnerID,
  };
};

export type updateFormSalesNoteSagaActionPayloadType = {
  id: number;
  source: "UserPartnerNote";
  data: { label: string; value: boolean }[];
};
export const updateFormSalesNoteSagaAction: (
  payload: updateFormSalesNoteSagaActionPayloadType
) => {
  type: string;
  payload: updateFormSalesNoteSagaActionPayloadType;
} = (payload) => {
  return {
    type: notesSagaActionTypes.callUpdateFormSalesNoteSaga,
    payload: payload,
  };
};

export const getNotesListSagaAction: (partnerID: number) => {
  type: string;
  partnerID: number;
} = (partnerID) => {
  return {
    type: notesSagaActionTypes.callGetNotesListSaga,
    partnerID,
  };
};

export const addNoteSagaAction: (payload: NoteType) => {
  type: string;
  payload: NoteType;
} = (payload) => {
  return {
    type: notesSagaActionTypes.callAddNoteSaga,
    payload,
  };
};

export const updateNoteSagaAction: (payload: NoteType) => {
  type: string;
  payload: NoteType;
} = (payload) => {
  return {
    type: notesSagaActionTypes.callUpdateNoteSaga,
    payload,
  };
};

export const deleteNoteSagaAction: (payload: {
  noteID: number;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  type: string;
  payload: {
    noteID: number;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };
} = (payload) => {
  return {
    type: notesSagaActionTypes.callDeleteNoteSaga,
    payload,
  };
};
